"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Handler = exports.Handlers = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.Handlers = ['email', 'sms', 'sendgrid', 'slack', 'in-app'];
exports.Handler = typebox_1.Type.Union(exports.Handlers.map((handler) => typebox_1.Type.Literal(handler)));
//# sourceMappingURL=handlers.js.map